export default function autenticacaoReducer(state = '', action) {
    if (action.type === 'LOGIN_SUCCESS') {
        return action.nomeUsuario;
    }
    if (action.type === 'LOGOUT_SUCCESS') {
        return '';
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/redux/reducers/autenticacaoReducer.js